var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-slideout",
      class: { open: _vm.open },
      on: { click: _vm.toggleSlideout }
    },
    [
      _c(
        "div",
        {
          staticClass: "slideout pt-24 pt-lg-40",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", {
            staticClass: "close",
            on: { click: _vm.toggleSlideout }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "px-24 px-lg-40 mb-40" }, [
            _vm._v("Offerte aanvragen")
          ]),
          _vm._v(" "),
          _c("el-orders", {
            staticClass: "px-24 px-lg-40 mb-16",
            attrs: { canDelete: false },
            model: {
              value: _vm.abstractOrders,
              callback: function($$v) {
                _vm.abstractOrders = $$v
              },
              expression: "abstractOrders"
            }
          }),
          _vm._v(" "),
          _vm.formType == null || _vm.formType == "general"
            ? _c("el-orders-form", {
                staticClass: "px-24 px-lg-40 mb-0",
                attrs: { orders: _vm.orders, "copy-config": _vm.copyConfig }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.formType == "tribeBoxes"
            ? _c("el-tribe-box-form", {
                staticClass: "px-24 px-lg-40 mb-0",
                attrs: { orders: _vm.orders, "copy-config": _vm.copyConfig }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }